// Central content for the Sasya Hero landing page.

// Official photos uploaded by Sasya Hero (customer assets) + matching studio shots.
const A = "https://customer-assets-wrfwihn1.emergentagent.net/job_hero-scooter-bikes/artifacts/";
const G = "https://static.prod-images.emergentagent.com/jobs/a7289ebf-51a7-4819-86cc-4de9359ae56b/images/";

export const IMG = {
  hero: G + "cdee6d6c46356501990d6923479845eebf420a079578338f32683c27f65dcce9.jpeg",
  legacy: G + "8597993a0caea8315646a5c083afc2c1acfba1d1794ed48d2b338741559c376f.jpeg",
  // Official Hero photos
  splendorXtec: A + "jysrz24v_Splendor%20%2B%20Xtec.webp",
  hfDeluxe: A + "bagfidpj_HF%20Deluxe.webp",
  passionPlus: A + "dsbl3uwy_Passion%20Plus.webp",
  superSplendor: A + "04834bna_Super%20Splednor%20X%20tec.webp",
  glamourX: A + "xc2i59uj_Glamour%20X.webp",
  xtreme125: A + "ahvltqkz_Xtreme%20125%20R.webp",
  xtreme160: A + "hk4du5gx_Xtreme%20160%20R.webp",
  xpulse210: A + "e9e42wul_Xplus%20210.png",
  pleasure: A + "lu6fldf5_Pleasure%20.webp",
  destini: A + "xseqkgm6_Destini%20125%20CC.webp",
  // Matching studio shots (models not yet supplied)
  karizma: A + "ufkfljrc_Karizma.webp",
  mavrick: A + "7w5afhfp_Mavreik.webp",
  maestro: A + "oxzlpgca_Mastero%20edge.webp",
  xoom110: A + "1slk679c_Xoom%20110.webp",
  xoom125: A + "3qjq0og0_Xoom%20125.webp",
  xoom160: G + "590ade942ee72d75e90ef16b2edf189a0dfebd4b6dfd283f2f82c5c08a3bc424.jpeg",
  vidaVX2: A + "9h8lqkm0_Vida%20VX%202.webp",
  vidaV2: A + "z5bg96m7_Vida%20V2.webp",
  glamourOG: A + "mqvdbpfh_Glamour%20OG.png",
  heroLogo: A + "iepqsrux_Hero%20logo.png",
  vidaLogo: A + "wu7lokni_Vida.webp",
  showroom: A + "z2vo3n5a_unnamed.webp",
  dirtek3: G + "00eea6ee16f1001b925a4cef3e29c4875549d48f320704fc67d26f61639dc279.jpeg",
};

export const MOTORCYCLES = [
  { name: "HF Deluxe", cc: "97.2 cc", spec: "Legendary mileage", img: IMG.hfDeluxe },
  { name: "Splendor Plus XTEC", cc: "97.2 cc", spec: "60+ kmpl • Commuter", img: IMG.splendorXtec, tag: "Best Seller" },
  { name: "Passion Plus", cc: "113 cc", spec: "Style + comfort", img: IMG.passionPlus },
  { name: "Glamour", cc: "124.7 cc", spec: "Classic 125cc", img: IMG.glamourOG },
  { name: "Glamour XTEC", cc: "124.7 cc", spec: "Premium 125cc", img: IMG.glamourX },
  { name: "Super Splendor XTEC", cc: "124.7 cc", spec: "Power commuter", img: IMG.superSplendor },
  { name: "Xtreme 125R", cc: "124.7 cc", spec: "Sportiest 125", img: IMG.xtreme125, tag: "Sport" },
  { name: "Xtreme 160R 4V", cc: "163 cc", spec: "Street performance", img: IMG.xtreme160, tag: "Sport" },
  { name: "Karizma XMR", cc: "210 cc", spec: "Faired sport tourer", img: IMG.karizma, tag: "Flagship" },
  { name: "Xpulse 200 4V", cc: "199.6 cc", spec: "Adventure ready", img: IMG.xpulse210, tag: "ADV" },
  { name: "Mavrick 440", cc: "440 cc", spec: "Roadster muscle", img: IMG.mavrick, tag: "New" },
];

export const SCOOTERS = [
  { name: "Pleasure+ XTEC", cc: "110 cc", spec: "Light & easy", img: IMG.pleasure, tag: "Ladies' Choice" },
  { name: "Destini 125 XTEC", cc: "124.6 cc", spec: "Family comfort", img: IMG.destini },
  { name: "Maestro Edge 125", cc: "124.6 cc", spec: "Sporty ride", img: IMG.maestro },
  { name: "Xoom 110", cc: "110.9 cc", spec: "Agile city scooter", img: IMG.xoom110, tag: "Popular" },
  { name: "Xoom 125", cc: "124.6 cc", spec: "Turn-by-turn nav", img: IMG.xoom125 },
];

export const VIDA = [
  { name: "VIDA VX2 Go", cc: "3.1 kWh", spec: "Range 100 km • Removable battery", img: IMG.vidaVX2, tag: "Electric" },
  { name: "VIDA VX2 Plus", cc: "4.4 kWh", spec: "IDC Range 142 km", img: IMG.vidaVX2, tag: "Long Range" },
  { name: "VIDA V2 Pro", cc: "3.9 kWh", spec: "IDC Range 127 km • 70 km/h", img: IMG.vidaV2, tag: "Flagship" },
  { name: "VIDA V2 Plus", cc: "3.4 kWh", spec: "Smart connected ride", img: IMG.vidaV2 },
  { name: "VIDA VX2 Go 3.4", cc: "3.4 kWh", spec: "Everyday electric", img: IMG.vidaVX2 },
];

// Service-booking bike model dropdown — Hero MotoCorp & Hero Honda models.
export const BIKE_MODELS = [
  "Hero Splendor Plus",
  "Hero Splendor Plus XTEC",
  "Hero Splendor iSmart",
  "Hero Super Splendor",
  "Hero HF Deluxe",
  "Hero HF 100",
  "Hero Passion Plus",
  "Hero Passion Pro",
  "Hero Glamour",
  "Hero Glamour XTEC",
  "Hero Xtreme 125R",
  "Hero Xtreme 160R",
  "Hero Xtreme 200S",
  "Hero Xtreme 250R",
  "Hero Xpulse 200 4V",
  "Hero Xpulse 210",
  "Hero Karizma XMR",
  "Hero Mavrick 440",
  "Hero Pleasure / Pleasure+",
  "Hero Maestro Edge 110 / 125",
  "Hero Destini 125",
  "Hero Xoom 110 / 125 / 160",
  "VIDA V1 / V2 / VX2",
  "Hero Honda Splendor",
  "Hero Honda Splendor Pro",
  "Hero Honda Passion",
  "Hero Honda CD Deluxe / Dawn",
  "Hero Honda CBZ / CBZ Xtreme",
  "Hero Honda Hunk",
  "Hero Honda Karizma / Karizma ZMR",
  "Hero Honda Glamour / Glamour FI",
  "Hero Honda Achiever",
  "Hero Honda Super Splendor",
  "Hero Honda Pleasure",
  "Other (mention in notes)",
];

export const CONTACTS = [
  { label: "General Enquiry", phone: "9281452805" },
  { label: "Main Showroom", phone: "8886017777" },
  { label: "Extension Showroom", phone: "8886533318" },
  { label: "Kodumur Showroom", phone: "9392904577" },
];

export const SHOWROOMS = [
  {
    name: "Sasya Hero — Main Showroom",
    phone: "8886017777",
    map: "https://maps.app.goo.gl/o4cLskSh914ko5si9",
    embed: "https://maps.google.com/maps?q=Sasya%20Hero%20MotoCorp%20Kurnool&t=&z=14&ie=UTF8&iwloc=&output=embed",
    blurb: "Sales, finance & test rides for the full Hero & VIDA range.",
  },
  {
    name: "Sasya Hero — Extension Showroom",
    phone: "8886533318",
    map: "https://maps.app.goo.gl/CHWqLUCUv9gz9ge47",
    embed: "https://maps.google.com/maps?q=Sasya%20Hero%20Extension%20Showroom%20Kurnool&t=&z=14&ie=UTF8&iwloc=&output=embed",
    blurb: "Extended experience zone with more display & delivery bays.",
  },
];

export const INSTAGRAM = "https://www.instagram.com/sasyahero?utm_source=qr";
export const WHATSAPP_MAIN = "919281452805";
